import { render } from "./DateType.vue?vue&type=template&id=55e07966&scoped=true&ts=true"
import script from "./DateType.vue?vue&type=script&lang=ts"
export * from "./DateType.vue?vue&type=script&lang=ts"

import "./DateType.vue?vue&type=style&index=0&id=55e07966&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e07966"]])

export default __exports__